



// "use client"

// import { useState, useEffect } from "react"
// import { Link, useParams, useNavigate } from "react-router-dom"
// import axios from "axios"
// import { baseUrl } from "../config/baseUrl"
// import empty from "../assets/images/empty-box.png"
// import Swal from "sweetalert2"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//     faQuestionCircle,
//     faPlus,
//     faCheck,
//     faTimes,
//     faSearch,
//     faArrowLeft,
//     faSave,
// } from "@fortawesome/free-solid-svg-icons"

// export default function AssignQuestionList() {
//     const { id } = useParams() // Get test ID from URL params
//     const navigate = useNavigate()

//     const [questions, setQuestions] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [searchTerm, setSearchTerm] = useState("")
//     const [statusFilter, setStatusFilter] = useState("active") // Default to active questions
//     const [language, setLanguage] = useState("english")
//     const [testDetails, setTestDetails] = useState(null)
//     const [loadingTest, setLoadingTest] = useState(true)
//     const [assigningQuestion, setAssigningQuestion] = useState(false)
//     const [subjectFilter, setSubjectFilter] = useState("")
//     const [subjects, setSubjects] = useState([])
//     const [selectedQuestions, setSelectedQuestions] = useState([])
//     const [savingChanges, setSavingChanges] = useState(false)
//     const [hasChanges, setHasChanges] = useState(false)

//     useEffect(() => {
//         fetchQuestions()
//         fetchTestDetails()
//     }, [id])

//     useEffect(() => {
//         // Extract unique subjects from questions
//         if (questions.length > 0) {
//             const uniqueSubjects = [...new Set(questions.map((q) => q.subject).filter(Boolean))]
//             setSubjects(uniqueSubjects)
//         }
//     }, [questions])

//     const fetchTestDetails = async () => {
//         try {
//             setLoadingTest(true)
//             const response = await axios.get(`${baseUrl}/test`, {
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })

//             if (response.data.status) {
//                 const testList = response.data.data || []
//                 const test = testList.find((t) => t._id === id)

//                 if (test) {
//                     setTestDetails(test)
//                     // Pre-select questions that are already assigned to this test
//                     if (test.questions && Array.isArray(test.questions)) {
//                         setSelectedQuestions(test.questions)
//                     }
//                 } else {
//                     Swal.fire({
//                         title: "Error!",
//                         text: "Test not found",
//                         icon: "error",
//                     })
//                     navigate("/test-series")
//                 }
//             }
//         } catch (error) {
//             console.error("Error fetching test details:", error)
//             Swal.fire({
//                 title: "Error!",
//                 text: "Failed to fetch test details",
//                 icon: "error",
//             })
//         } finally {
//             setLoadingTest(false)
//         }
//     }

//     const fetchQuestions = async () => {
//         try {
//             setLoading(true)
//             const response = await axios.get(`${baseUrl}/question`, {
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })
//             setQuestions(response.data.data)
//         } catch (error) {
//             console.log("error", error)
//             Swal.fire({
//                 title: "Error!",
//                 text: "Failed to fetch questions",
//                 icon: "error",
//             })
//         } finally {
//             setLoading(false)
//         }
//     }

//     // Helper function to get question text based on language
//     const getQuestionText = (question, lang) => {
//         if (lang === "english") {
//             return question?.question_english || question?.questions || ""
//         } else if (lang === "hindi") {
//             return question?.question_hindi || question?.questions || ""
//         } else if (lang === "bengali") {
//             return question?.question_bengali || question?.questions || ""
//         }
//         return question?.question_english || question?.questions || ""
//     }

//     // Check if a question is already assigned to the test
//     const isQuestionAssigned = (questionId) => {
//         return selectedQuestions.includes(questionId)
//     }

//     // Handle toggling a question selection
//     const handleToggleQuestion = (questionId) => {
//         let updatedQuestions = [...selectedQuestions]

//         if (updatedQuestions.includes(questionId)) {
//             // Remove the question if already selected
//             updatedQuestions = updatedQuestions.filter((id) => id !== questionId)
//         } else {
//             // Add the question if not already selected
//             updatedQuestions.push(questionId)
//         }

//         setSelectedQuestions(updatedQuestions)
//         setHasChanges(true)
//     }

//     // Save all selected questions at once using the new API
//     const saveSelectedQuestions = async () => {
//         try {
//             setSavingChanges(true)

//             // Call the new dedicated API endpoint for question selection
//             const response = await axios.post(
//                 `${baseUrl}/question_selected`,
//                 {
//                     testID: id,
//                     questionsID: selectedQuestions,
//                 },
//                 {
//                     headers: {
//                         Authorization: localStorage.getItem("token"),
//                         "Content-Type": "application/json",
//                     },
//                 },
//             )

//             if (response.data && response.data.status) {
//                 Swal.fire({
//                     title: "Success!",
//                     text: "Questions assigned to test successfully",
//                     icon: "success",
//                     timer: 1500,
//                     showConfirmButton: false,
//                 })
//                 setHasChanges(false)
//             } else {
//                 Swal.fire({
//                     title: "Error!",
//                     text: response.data?.message || "Failed to assign questions",
//                     icon: "error",
//                 })
//             }
//         } catch (error) {
//             console.error("Error saving selected questions:", error)
//             Swal.fire({
//                 title: "Error!",
//                 text: "Failed to save question selections. Please try again.",
//                 icon: "error",
//             })
//         } finally {
//             setSavingChanges(false)
//         }
//     }

//     // Filter questions based on search term, status, subject, and handle multilingual search
//     const filteredQuestions = questions.filter((question) => {
//         // Get the appropriate question text based on selected language
//         const questionText = getQuestionText(question, language)
//         const subject = question?.subject || ""
//         const topic = question?.topic || ""

//         const matchesSearch =
//             questionText?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             subject?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             topic?.toLowerCase().includes(searchTerm.toLowerCase())

//         const matchesStatus = statusFilter === "" || question.status === statusFilter
//         const matchesSubject = subjectFilter === "" || question.subject === subjectFilter

//         return matchesSearch && matchesStatus && matchesSubject
//     })

//     const truncateText = (text, maxLength = 50) => {
//         if (!text) return ""
//         return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
//     }

//     if (loadingTest) {
//         return (
//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-12 text-center py-5">
//                             <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                             </div>
//                             <p className="mt-3">Loading test details...</p>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         )
//     }

//     return (
//         <>
//             <style jsx>{`
//         .main-sec {
//           background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
//           min-height: 100vh;
//           padding: 2rem 0;
//         }

//         .dashboard-title {
//           margin-bottom: 1.5rem;
//         }

//         .dash-head {
//           color: #333;
//           font-size: 1.8rem;
//           font-weight: 700;
//           margin: 0;
//         }

//         .cards {
//           background: white;
//           border-radius: 15px;
//           padding: 2rem;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//           margin-bottom: 2rem;
//         }

//         .bus-filter {
//           margin-bottom: 2rem;
//           padding-bottom: 1.5rem;
//           border-bottom: 1px solid #eee;
//         }

//         .card-title {
//           color: #333;
//           font-weight: 700;
//           margin: 0;
//         }

//         .btn-add-question {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 1.5rem;
//           color: white;
//           font-weight: 600;
//           text-decoration: none;
//           transition: all 0.3s ease;
//         }

//         .btn-add-question:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
//           color: white;
//         }

//         .btn-save-all {
//           background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 1.5rem;
//           color: white;
//           font-weight: 600;
//           transition: all 0.3s ease;
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .btn-save-all:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(67, 233, 123, 0.3);
//         }

//         .btn-save-all:disabled {
//           background: #cccccc;
//           cursor: not-allowed;
//           transform: none;
//           box-shadow: none;
//         }

//         .search-filter-container {
//           display: flex;
//           gap: 1rem;
//           margin-bottom: 1.5rem;
//           flex-wrap: wrap;
//         }

//         .search-input {
//           flex: 1;
//           min-width: 250px;
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           padding-left: 2.5rem;
//           position: relative;
//         }

//         .search-container {
//           position: relative;
//           flex: 1;
//           min-width: 250px;
//         }

//         .search-icon {
//           position: absolute;
//           left: 0.75rem;
//           top: 50%;
//           transform: translateY(-50%);
//           color: #999;
//         }

//         .status-filter, .subject-filter {
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           min-width: 150px;
//         }

//         .custom-table {
//           border-radius: 10px;
//           overflow: hidden;
//         }

//         .table {
//           margin: 0;
//         }

//         .table thead th {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           font-weight: 600;
//           border: none;
//           padding: 1rem;
//         }

//         .table tbody td {
//           padding: 1rem;
//           vertical-align: middle;
//           border-bottom: 1px solid #f0f0f0;
//         }

//         .table tbody tr:hover {
//           background-color: #f8f9ff;
//         }

//         .question-text {
//           max-width: 300px;
//           font-weight: 500;
//         }

//         .status-badge {
//           padding: 0.5rem 1rem;
//           border-radius: 20px;
//           font-size: 0.85rem;
//           font-weight: 600;
//           border: none;
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }

//         .status-active {
//           background: #d4edda;
//           color: #155724;
//         }

//         .status-inactive {
//           background: #f8d7da;
//           color: #721c24;
//         }

//         .status-badge:hover {
//           transform: scale(1.05);
//         }

//         .assign-btn {
//           background: #4facfe;
//           color: white;
//           border: none;
//           border-radius: 8px;
//           padding: 0.5rem 1rem;
//           font-weight: 600;
//           transition: all 0.3s ease;
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .assign-btn:hover {
//           background: #2f86fe;
//           transform: translateY(-2px);
//           box-shadow: 0 5px 15px rgba(79, 172, 254, 0.3);
//         }

//         .remove-btn {
//           background: #ef5350;
//           color: white;
//           border: none;
//           border-radius: 8px;
//           padding: 0.5rem 1rem;
//           font-weight: 600;
//           transition: all 0.3s ease;
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .remove-btn:hover {
//           background: #e53935;
//           transform: translateY(-2px);
//           box-shadow: 0 5px 15px rgba(239, 83, 80, 0.3);
//         }

//         .assigned-badge {
//           background: #d4edda;
//           color: #155724;
//           border-radius: 20px;
//           padding: 0.5rem 1rem;
//           font-size: 0.85rem;
//           font-weight: 600;
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .empty-state {
//           text-align: center;
//           padding: 3rem;
//         }

//         .empty-state img {
//           opacity: 0.7;
//           margin-bottom: 1rem;
//         }

//         .empty-state h4 {
//           color: #666;
//           margin-bottom: 1rem;
//         }

//         .loading-spinner {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           padding: 3rem;
//         }

//         .spinner {
//           width: 40px;
//           height: 40px;
//           border: 4px solid #f3f3f3;
//           border-top: 4px solid #667eea;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         .test-info {
//           background: #f8f9ff;
//           border-left: 4px solid #667eea;
//           padding: 1rem;
//           border-radius: 8px;
//           margin-bottom: 1.5rem;
//         }

//         .test-info h5 {
//           color: #333;
//           font-weight: 700;
//           margin-bottom: 0.5rem;
//         }

//         .test-info p {
//           margin-bottom: 0.25rem;
//           color: #666;
//         }

//         .test-info .badge {
//           font-size: 0.85rem;
//           padding: 0.35em 0.65em;
//           margin-left: 0.5rem;
//         }

//         .selection-summary {
//           background: #fff8e1;
//           border-left: 4px solid #ffc107;
//           padding: 1rem;
//           border-radius: 8px;
//           margin-bottom: 1.5rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .selection-summary p {
//           margin: 0;
//           font-weight: 500;
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @media (max-width: 768px) {
//           .search-filter-container {
//             flex-direction: column;
//           }

//           .search-container,
//           .status-filter,
//           .subject-filter {
//             min-width: 100%;
//           }

//           .table-responsive {
//             font-size: 0.85rem;
//           }

//           .question-text {
//             max-width: 200px;
//           }
//         }
//       `}</style>

//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-6">
//                             <div className="dashboard-title">
//                                 <h4 className="dash-head">
//                                     <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
//                                     Assign Questions to Test
//                                 </h4>
//                             </div>
//                             <div className="custom-bredcump">
//                                 <nav aria-label="breadcrumb">
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item">
//                                             <Link to="/">Dashboard</Link>
//                                         </li>
//                                         <li className="breadcrumb-item">
//                                             <Link to="/test-series">Tests</Link>
//                                         </li>
//                                         <li className="breadcrumb-item active" aria-current="page">
//                                             Assign Questions
//                                         </li>
//                                     </ol>
//                                 </nav>
//                             </div>
//                         </div>
//                         <div className="col-lg-6 d-flex justify-content-end align-items-start">
//                             <Link to="/test-series" className="btn-add-question me-2">
//                                 <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
//                                 Back to Tests
//                             </Link>
//                             <button className="btn-save-all" onClick={saveSelectedQuestions} disabled={!hasChanges || savingChanges}>
//                                 {savingChanges ? (
//                                     <>
//                                         <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                                         <span className="ms-2">Saving...</span>
//                                     </>
//                                 ) : (
//                                     <>
//                                         <FontAwesomeIcon icon={faSave} />
//                                         Save Changes
//                                     </>
//                                 )}
//                             </button>
//                         </div>
//                     </div>

//                     {testDetails && (
//                         <div className="row mb-4">
//                             <div className="col-lg-12">
//                                 <div className="test-info">
//                                     <h5>
//                                         {testDetails.title}
//                                         <span className={`badge ${testDetails.status === "active" ? "bg-success" : "bg-danger"}`}>
//                                             {testDetails.status}
//                                         </span>
//                                     </h5>
//                                     <p>
//                                         <strong>Questions Assigned:</strong> {selectedQuestions.length}
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {hasChanges && (
//                         <div className="row mb-4">
//                             <div className="col-lg-12">
//                                 <div className="selection-summary">
//                                     <p>
//                                         <FontAwesomeIcon icon={faCheck} className="me-2" />
//                                         You have made changes to the question selection. Don't forget to save your changes!
//                                     </p>
//                                     <button className="btn-save-all btn-sm" onClick={saveSelectedQuestions} disabled={savingChanges}>
//                                         {savingChanges ? (
//                                             <>
//                                                 <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                                                 <span className="ms-2">Saving...</span>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <FontAwesomeIcon icon={faSave} />
//                                                 Save Now
//                                             </>
//                                         )}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     <div className="row">
//                         <div className="col-lg-12">
//                             <div className="cards bus-list">
//                                 <div className="bus-filter">
//                                     <div className="row align-items-center">
//                                         <div className="col-lg-6">
//                                             <h5 className="card-title">Questions List ({filteredQuestions.length})</h5>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="search-filter-container">
//                                     <div className="search-container">
//                                         <FontAwesomeIcon icon={faSearch} className="search-icon" />
//                                         <input
//                                             type="text"
//                                             className="search-input"
//                                             placeholder="Search questions..."
//                                             value={searchTerm}
//                                             onChange={(e) => setSearchTerm(e.target.value)}
//                                         />
//                                     </div>
//                                     <select
//                                         className="status-filter"
//                                         value={statusFilter}
//                                         onChange={(e) => setStatusFilter(e.target.value)}
//                                     >
//                                         <option value="">All Status</option>
//                                         <option value="active">Active</option>
//                                         <option value="inactive">Inactive</option>
//                                     </select>
//                                     <select
//                                         className="subject-filter"
//                                         value={subjectFilter}
//                                         onChange={(e) => setSubjectFilter(e.target.value)}
//                                     >
//                                         <option value="">All Subjects</option>
//                                         {subjects.map((subject) => (
//                                             <option key={subject} value={subject}>
//                                                 {subject}
//                                             </option>
//                                         ))}
//                                     </select>
//                                     <select className="status-filter" value={language} onChange={(e) => setLanguage(e.target.value)}>
//                                         <option value="english">English</option>
//                                         <option value="hindi">Hindi</option>
//                                         <option value="bengali">Bengali</option>
//                                     </select>
//                                 </div>

//                                 <div className="table-responsive custom-table">
//                                     <table className="table table-borderless">
//                                         <thead>
//                                             <tr>
//                                                 <th>SN</th>
//                                                 <th>Question</th>
//                                                 <th>Subject</th>
//                                                 <th>Topic</th>
//                                                 <th>Status</th>
//                                                 <th>Action</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {loading ? (
//                                                 <tr>
//                                                     <td colSpan="6" className="loading-spinner">
//                                                         <div className="spinner"></div>
//                                                     </td>
//                                                 </tr>
//                                             ) : filteredQuestions.length === 0 ? (
//                                                 <tr>
//                                                     <td colSpan="6" className="empty-state">
//                                                         <img src={empty || "/placeholder.svg"} alt="No questions" width="200px" />
//                                                         <h4>No Questions found!</h4>
//                                                         <p className="text-muted">
//                                                             {searchTerm || statusFilter || subjectFilter
//                                                                 ? "Try adjusting your search or filter criteria"
//                                                                 : "Start by adding your first question"}
//                                                         </p>
//                                                     </td>
//                                                 </tr>
//                                             ) : (
//                                                 filteredQuestions.map((question, i) => (
//                                                     <tr key={question?._id}>
//                                                         <td>{i + 1}</td>
//                                                         <td>
//                                                             <div className="question-text">
//                                                                 {truncateText(getQuestionText(question, language), 60)}
//                                                             </div>
//                                                         </td>
//                                                         <td>{question?.subject || "N/A"}</td>
//                                                         <td>{question?.topic || "N/A"}</td>
//                                                         <td>
//                                                             <span
//                                                                 className={`status-badge ${question.status === "active" ? "status-active" : "status-inactive"
//                                                                     }`}
//                                                             >
//                                                                 {question?.status === "active" ? (
//                                                                     <>
//                                                                         <FontAwesomeIcon icon={faCheck} className="me-1" />
//                                                                         Active
//                                                                     </>
//                                                                 ) : (
//                                                                     <>
//                                                                         <FontAwesomeIcon icon={faTimes} className="me-1" />
//                                                                         Inactive
//                                                                     </>
//                                                                 )}
//                                                             </span>
//                                                         </td>
//                                                         <td>
//                                                             {isQuestionAssigned(question._id) ? (
//                                                                 <>
//                                                                     <button
//                                                                         className="remove-btn"
//                                                                         onClick={() => handleToggleQuestion(question._id)}
//                                                                         disabled={savingChanges}
//                                                                     >
//                                                                         <FontAwesomeIcon icon={faTimes} />
//                                                                         Remove
//                                                                     </button>
//                                                                 </>
//                                                             ) : (
//                                                                 <button
//                                                                     className="assign-btn"
//                                                                     onClick={() => handleToggleQuestion(question._id)}
//                                                                     disabled={savingChanges}
//                                                                 >
//                                                                     <FontAwesomeIcon icon={faPlus} />
//                                                                     Assign
//                                                                 </button>
//                                                             )}
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     )
// }





















"use client"

import { useState, useEffect } from "react"
import { Link, useParams, useNavigate } from "react-router-dom"
import axios from "axios"
import { baseUrl } from "../config/baseUrl"
import empty from "../assets/images/empty-box.png"
import Swal from "sweetalert2"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faQuestionCircle,
    faPlus,
    faCheck,
    faTimes,
    faSearch,
    faArrowLeft,
    faSave,
} from "@fortawesome/free-solid-svg-icons"

export default function AssignQuestionList() {
    const { id } = useParams() // Get test ID from URL params
    const navigate = useNavigate()

    const [questions, setQuestions] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState("")
    const [statusFilter, setStatusFilter] = useState("active") // Default to active questions
    const [language, setLanguage] = useState("english")
    const [testDetails, setTestDetails] = useState(null)
    const [loadingTest, setLoadingTest] = useState(true)
    const [assigningQuestion, setAssigningQuestion] = useState(false)
    const [subjectFilter, setSubjectFilter] = useState("")
    const [subjects, setSubjects] = useState([])
    const [selectedQuestions, setSelectedQuestions] = useState([])
    const [savingChanges, setSavingChanges] = useState(false)
    const [hasChanges, setHasChanges] = useState(false)

    useEffect(() => {
        fetchQuestions()
        fetchTestDetails()
    }, [id])

    useEffect(() => {
        // Extract unique subjects from questions
        if (questions.length > 0) {
            const uniqueSubjects = [...new Set(questions.map((q) => q.subject).filter(Boolean))]
            setSubjects(uniqueSubjects)
        }
    }, [questions])

    const fetchTestDetails = async () => {
        try {
            setLoadingTest(true)
            const response = await axios.get(`${baseUrl}/test`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            })

            if (response.data.status) {
                const testList = response.data.data || []
                const test = testList.find((t) => t._id === id)

                if (test) {
                    setTestDetails(test)
                    // Fetch assigned questions for this test
                    await fetchAssignedQuestions()
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: "Test not found",
                        icon: "error",
                    })
                    navigate("/test-series")
                }
            }
        } catch (error) {
            console.error("Error fetching test details:", error)
            Swal.fire({
                title: "Error!",
                text: "Failed to fetch test details",
                icon: "error",
            })
        } finally {
            setLoadingTest(false)
        }
    }

    const fetchAssignedQuestions = async () => {
        try {
            const response = await axios.post(
                `${baseUrl}/question_selected/test-questions`,
                { testId: id },
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                        "Content-Type": "application/json",
                    },
                },
            )

            if (response.data.status) {
                const assignedQuestions = response.data.data || []
                // Extract question IDs from the assigned questions
                const assignedQuestionIds = assignedQuestions.map((q) => q._id)
                setSelectedQuestions(assignedQuestionIds)
            }
        } catch (error) {
            console.error("Error fetching assigned questions:", error)
        }
    }

    const fetchQuestions = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`${baseUrl}/question`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            })
            setQuestions(response.data.data)
        } catch (error) {
            console.log("error", error)
            Swal.fire({
                title: "Error!",
                text: "Failed to fetch questions",
                icon: "error",
            })
        } finally {
            setLoading(false)
        }
    }

    // Helper function to get question text based on language
    const getQuestionText = (question, lang) => {
        if (lang === "english") {
            return question?.question_english || question?.questions || ""
        } else if (lang === "hindi") {
            return question?.question_hindi || question?.questions || ""
        } else if (lang === "bengali") {
            return question?.question_bengali || question?.questions || ""
        }
        return question?.question_english || question?.questions || ""
    }

    // Check if a question is already assigned to the test
    const isQuestionAssigned = (questionId) => {
        return selectedQuestions.includes(questionId)
    }

    // Handle toggling a question selection
    const handleToggleQuestion = (questionId) => {
        let updatedQuestions = [...selectedQuestions]

        if (updatedQuestions.includes(questionId)) {
            // Remove the question if already selected
            updatedQuestions = updatedQuestions.filter((id) => id !== questionId)
        } else {
            // Add the question if not already selected
            updatedQuestions.push(questionId)
        }

        setSelectedQuestions(updatedQuestions)
        setHasChanges(true)
    }

    // Save all selected questions at once using the new API
    const saveSelectedQuestions = async () => {
        try {
            setSavingChanges(true)

            // Call the new dedicated API endpoint for question selection
            const response = await axios.post(
                `${baseUrl}/question_selected`,
                {
                    testID: id,
                    questionsID: selectedQuestions,
                },
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                        "Content-Type": "application/json",
                    },
                },
            )

            if (response.data && response.data.status) {
                Swal.fire({
                    title: "Success!",
                    text: "Questions assigned to test successfully",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                })
                setHasChanges(false)
            } else {
                Swal.fire({
                    title: "Error!",
                    text: response.data?.message || "Failed to assign questions",
                    icon: "error",
                })
            }
        } catch (error) {
            console.error("Error saving selected questions:", error)
            Swal.fire({
                title: "Error!",
                text: "Failed to save question selections. Please try again.",
                icon: "error",
            })
        } finally {
            setSavingChanges(false)
        }
    }

    // Filter questions based on search term, status, subject, and handle multilingual search
    const filteredQuestions = questions.filter((question) => {
        // Get the appropriate question text based on selected language
        const questionText = getQuestionText(question, language)
        const subject = question?.subject || ""
        const topic = question?.topic || ""

        const matchesSearch =
            questionText?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            subject?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            topic?.toLowerCase().includes(searchTerm.toLowerCase())

        const matchesStatus = statusFilter === "" || question.status === statusFilter
        const matchesSubject = subjectFilter === "" || question.subject === subjectFilter

        return matchesSearch && matchesStatus && matchesSubject
    })

    const truncateText = (text, maxLength = 50) => {
        if (!text) return ""
        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
    }

    if (loadingTest) {
        return (
            <section className="main-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Loading test details...</p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <>
            <section className="main-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="dashboard-title">
                                <h4 className="dash-head">
                                    <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
                                    Assign Questions to Test
                                </h4>
                            </div>
                            <div className="custom-bredcump">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/test-series">Tests</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Assign Questions
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-end align-items-start">
                            <Link to="/test-series" className="btn-add-question me-2">
                                <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                                Back to Tests
                            </Link>
                            <button className="btn-save-all" onClick={saveSelectedQuestions} disabled={!hasChanges || savingChanges}>
                                {savingChanges ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span className="ms-2">Saving...</span>
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faSave} />
                                        Save Changes
                                    </>
                                )}
                            </button>
                        </div>
                    </div>

                    {testDetails && (
                        <div className="row mb-4">
                            <div className="col-lg-12">
                                <div className="test-info">
                                    <h5>
                                        {testDetails.title}
                                        <span className={`badge ${testDetails.status === "active" ? "bg-success" : "bg-danger"}`}>
                                            {testDetails.status}
                                        </span>
                                    </h5>
                                    <p>
                                        <strong>Questions Assigned:</strong> {selectedQuestions.length}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row mb-4">
                        <div className="col-lg-12">
                            <div className="cards bus-list">
                                <div className="bus-filter">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6">
                                            <h5 className="card-title">Questions List ({filteredQuestions.length})</h5>
                                        </div>
                                    </div>
                                </div>

                                <div className="search-filter-container">
                                    <div className="search-container">
                                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                                        <input
                                            type="text"
                                            className="search-input"
                                            placeholder="Search questions..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    <select
                                        className="status-filter"
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option value="">All Status</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                    <select
                                        className="subject-filter"
                                        value={subjectFilter}
                                        onChange={(e) => setSubjectFilter(e.target.value)}
                                    >
                                        <option value="">All Subjects</option>
                                        {subjects.map((subject) => (
                                            <option key={subject} value={subject}>
                                                {subject}
                                            </option>
                                        ))}
                                    </select>
                                    <select className="status-filter" value={language} onChange={(e) => setLanguage(e.target.value)}>
                                        <option value="english">English</option>
                                        <option value="hindi">Hindi</option>
                                        <option value="bengali">Bengali</option>
                                    </select>
                                </div>

                                <div className="table-responsive custom-table">
                                    <table className="table table-borderless">
                                        <thead>
                                            <tr>
                                                <th>SN</th>
                                                <th>Question</th>
                                                <th>Subject</th>
                                                <th>Topic</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="6" className="loading-spinner">
                                                        <div className="spinner"></div>
                                                    </td>
                                                </tr>
                                            ) : filteredQuestions.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6" className="empty-state">
                                                        <img src={empty || "/placeholder.svg"} alt="No questions" width="200px" />
                                                        <h4>No Questions found!</h4>
                                                        <p className="text-muted">
                                                            {searchTerm || statusFilter || subjectFilter
                                                                ? "Try adjusting your search or filter criteria"
                                                                : "Start by adding your first question"}
                                                        </p>
                                                    </td>
                                                </tr>
                                            ) : (
                                                filteredQuestions.map((question, i) => (
                                                    <tr
                                                        key={question?._id}
                                                        className={isQuestionAssigned(question._id) ? "question-row-assigned" : ""}
                                                    >
                                                        <td>{i + 1}</td>
                                                        <td>
                                                            <div
                                                                className={`question-text ${isQuestionAssigned(question._id) ? "question-text-assigned" : ""}`}
                                                            >
                                                                {truncateText(getQuestionText(question, language), 60)}
                                                                {isQuestionAssigned(question._id) && (
                                                                    <span className="assigned-badge">
                                                                        <FontAwesomeIcon icon={faCheck} />
                                                                        Already Assigned
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>{question?.subject || "N/A"}</td>
                                                        <td>{question?.topic || "N/A"}</td>
                                                        <td>
                                                            <span
                                                                className={`status-badge ${question.status === "active" ? "status-active" : "status-inactive"
                                                                    }`}
                                                            >
                                                                {question?.status === "active" ? (
                                                                    <>
                                                                        <FontAwesomeIcon icon={faCheck} className="me-1" />
                                                                        Active
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <FontAwesomeIcon icon={faTimes} className="me-1" />
                                                                        Inactive
                                                                    </>
                                                                )}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {isQuestionAssigned(question._id) ? (
                                                                <>
                                                                    <button
                                                                        className="remove-btn"
                                                                        onClick={() => handleToggleQuestion(question._id)}
                                                                        disabled={savingChanges}
                                                                    >
                                                                        <FontAwesomeIcon icon={faTimes} />
                                                                        Remove
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <button
                                                                    className="assign-btn"
                                                                    onClick={() => handleToggleQuestion(question._id)}
                                                                    disabled={savingChanges}
                                                                >
                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                    Assign
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <style jsx>{`
                .main-sec {
                    padding: 20px 0;
                }

                .dashboard-title {
                    margin-bottom: 15px;
                }

                .dash-head {
                    font-size: 24px;
                    color: #333;
                }

                .custom-bredcump {
                    margin-bottom: 20px;
                }

                .breadcrumb {
                    background-color: transparent;
                    padding: 0;
                }

                .breadcrumb-item a {
                    color: #007bff;
                    text-decoration: none;
                }

                .breadcrumb-item.active {
                    color: #6c757d;
                }

                .btn-add-question {
                    background-color: #28a745;
                    color: white;
                    padding: 10px 15px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                    text-decoration: none;
                    display: inline-flex;
                    align-items: center;
                }

                .btn-add-question:hover {
                    background-color: #218838;
                }

                .btn-save-all {
                    background-color: #007bff;
                    color: white;
                    padding: 10px 15px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                    display: inline-flex;
                    align-items: center;
                }

                .btn-save-all:disabled {
                    background-color: #ccc;
                    cursor: not-allowed;
                }

                .btn-save-all:hover:not(:disabled) {
                    background-color: #0056b3;
                }

                .test-info {
                    background-color: #f8f9fa;
                    padding: 15px;
                    border-radius: 5px;
                    margin-bottom: 20px;
                }

                .test-info h5 {
                    margin-bottom: 10px;
                    font-size: 20px;
                }

                .badge {
                    margin-left: 10px;
                    font-size: 14px;
                }

                .selection-summary {
                    background-color: #fff3cd;
                    padding: 15px;
                    border-radius: 5px;
                    margin-bottom: 20px;
                    color: #856404;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .selection-summary p {
                    margin-bottom: 0;
                }

                .cards {
                    border: none;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                    border-radius: 5px;
                }

                .bus-list {
                    padding: 20px;
                }

                .bus-filter {
                    margin-bottom: 20px;
                }

                .card-title {
                    font-size: 18px;
                    color: #333;
                }

                .search-filter-container {
                    display: flex;
                    gap: 10px;
                    margin-bottom: 15px;
                }

                .search-container {
                    position: relative;
                    flex-grow: 1;
                }

                .search-icon {
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #aaa;
                }

                .search-input {
                    padding: 8px 10px 8px 30px;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    width: 100%;
                }

                .status-filter,
                .subject-filter {
                    padding: 8px 15px;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    width: auto;
                }

                .custom-table {
                    overflow-x: auto;
                }

                .table {
                    width: 100%;
                    border-collapse: collapse;
                }

                .table thead th {
                    background-color: #f2f2f2;
                    padding: 12px;
                    text-align: left;
                    border-bottom: 2px solid #ddd;
                }

                .table tbody td {
                    padding: 12px;
                    border-bottom: 1px solid #eee;
                }

                .table tbody tr:hover {
                    background-color: #f9f9f9;
                }

                .status-badge {
                    padding: 5px 10px;
                    border-radius: 5px;
                    font-size: 14px;
                    display: inline-flex;
                    align-items: center;
                }

                .status-active {
                    background-color: #d4edda;
                    color: #155724;
                }

                .status-inactive {
                    background-color: #f8d7da;
                    color: #721c24;
                }

                .assign-btn,
                .remove-btn {
                    padding: 8px 12px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    display: inline-flex;
                    align-items: center;
                    font-size: 14px;
                }

                .assign-btn {
                    background-color: #007bff;
                    color: white;
                }

                .assign-btn:hover {
                    background-color: #0056b3;
                }

                .remove-btn {
                    background-color: #dc3545;
                    color: white;
                }

                .remove-btn:hover {
                    background-color: #c82333;
                }

                .loading-spinner {
                    text-align: center;
                    padding: 20px;
                }

                .spinner {
                    border: 5px solid #f3f3f3;
                    border-top: 5px solid #3498db;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    animation: spin 2s linear infinite;
                    margin: 0 auto;
                }

                .empty-state {
                    text-align: center;
                    padding: 20px;
                }

                .empty-state img {
                    margin-bottom: 15px;
                }

                .question-text {
                    max-width: 300px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .question-row-assigned {
                    background-color: #e8f5e9 !important;
                    border-left: 4px solid #4caf50;
                }

                .question-row-assigned:hover {
                    background-color: #c8e6c9 !important;
                }

                .assigned-badge {
                    background: #4caf50;
                    color: white;
                    padding: 0.2rem 0.5rem;
                    border-radius: 12px;
                    font-size: 0.7rem;
                    font-weight: 600;
                    margin-left: 0.5rem;
                    display: inline-flex;
                    align-items: center;
                    gap: 0.25rem;
                }

                .question-text-assigned {
                    font-weight: 600;
                    color: #2e7d32;
                }
            `}</style>
        </>
    )
}
